"use client";

import { WalletServiceProvider } from "@/app/context";
import { APIUserData } from "@/app/types/user";
import GlobalDataProvider from "@/app/utils/store/Context/globalContext";
import { ReactNode } from "react";

type Props = {
  user: APIUserData | null;
  children: ReactNode;
  authMode: string;
};

export default function ClientLayout({
  children,
  user,
  authMode,
}: Readonly<Props>) {
  return (
    <GlobalDataProvider>
      <WalletServiceProvider user={user} authMode={authMode}>
        {children}
      </WalletServiceProvider>
    </GlobalDataProvider>
  );
}
